<template>
  <div v-if="outletInfo" class="cx-card cx-margin-overview cx-margin-overview-container">
    <figure class="figure">
      <img :src="outletInfo.image" class="local-image" alt="Description of Image">
    </figure>
    <div class="text">
      <div style="display: flex; ">
        <h5 class="scoped-header no-break">{{ outletInfo.name }}</h5>
      </div>
      <div class="no-break">
        <div>{{ outletInfo.address }}</div>
        <div>{{ outletInfo.zipCode }} {{ outletInfo.city }}</div>
        <div>({{ outletInfo.outletId }}) </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    outletInfo:             { type: Object, default: () => undefined },
    theme:                  { type: String, default: () => 'light' },
  }
}
</script>

<style scoped>
.cx-margin-overview-container {
    display: flex;
    gap: 1rem; /* Space between the figure and the text */
    margin-inline: 1rem;
}

.figure {
    flex: 0 0 7rem; /* Fixed width of 14rem */
    height: 7rem; /* Fixed height of 8rem */
    margin: 0; /* Remove default margin */
}

.figure img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensure the image covers the entire figure area */
}

.text {
    flex: 1; /* Take up the remaining space */
}

.no-break {
  padding-top: 0.25rem;
}

.cx-margin-overview figure img {
  overflow: hidden;
  max-height: 7rem;
  width: 10rem;
  object-fit: cover;
  aspect-ratio: 4/3;
}

h5 {
  line-height: 1.2;
  margin: 0rem;
}

.cx-margin-overview {
  padding: 1.0rem;
}

.scoped-header{
  font-weight: 600;
  font-size: 16pt;
  padding-right: 1rem;
}

</style>